/**
 * Rótulo e cor por status de vaga (mesmos 7 valores do CHECK de vagas_base,
 * mesmo texto/cor do kanban em VagaCard.tsx — mantido aqui em vez de
 * importado porque VagaCard não exporta essas constantes; qualquer mudança de
 * copy/cor do kanban deve espelhar aqui também).
 */
export const VAGA_STATUS_LABEL: Record<string, string> = {
  entrada: "Caixa de entrada",
  triagem: "Triagem",
  shortlist: "Shortlist",
  checagem_disponibilidade: "Checagem de disponibilidade",
  validacao: "Validação",
  aprovado: "Aprovada",
  reprovado: "Reprovada",
};

export const VAGA_STATUS_BAR_CLASS: Record<string, string> = {
  entrada: "bg-slate-300",
  triagem: "bg-blue-400",
  shortlist: "bg-blue-500",
  checagem_disponibilidade: "bg-indigo-500",
  validacao: "bg-purple-500",
  aprovado: "bg-emerald-500",
  reprovado: "bg-red-400",
};

export function vagaStatusLabel(status: string): string {
  return VAGA_STATUS_LABEL[status] ?? status;
}

export function vagaStatusBarClass(status: string): string {
  return VAGA_STATUS_BAR_CLASS[status] ?? "bg-slate-300";
}
